import React, { forwardRef } from "react";
import VideoPlay from "../../Components/VideoPlay/VideoPlay";
import "./VideoSection.css";
import ProfileDisplay from "../ProfileDisplay/ProfileDisplay";
// import FollowButton from "../FollowButton/FollowButton";
import ShareButton from "../ShareButton/ShareButton";
import VideoLoginUser from "../VideoLoginUser/VideoLoginUser";

const VideoSection = forwardRef(({ selectedVideo, instructor, instructor_title, onVideoEnd, autoPlay, instructor_photo, title }, ref) => {
  return (
    <div className="video-section">
      {selectedVideo ? (
        <>
          <VideoPlay 
            videoId={selectedVideo.id} 
            onVideoEnd={onVideoEnd}
            autoPlay={autoPlay}
            ref={ref}
          />
          <div className="class-title">
            <span className="class-font-title">{title}</span>
          </div>
        </>
      ) : (
        <>
          <VideoLoginUser />
          <div className="class-title">
            <span className="class-font-title"></span>
          </div>
        </>
      )}
      <div className="profile-component-sections">
        <ProfileDisplay
          instructor={instructor}
          instructor_title={instructor_title}
          instructor_photo={instructor_photo}
        />
        <div className="profile-component">
          {/* <FollowButton /> */}
          <ShareButton />
        </div>
      </div>
    </div>
  );
});

export default VideoSection;